import { render, staticRenderFns } from "./OwnersAssociations.vue?vue&type=template&id=71fd36ea&scoped=true&"
import script from "./OwnersAssociations.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociations.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociations.vue?vue&type=style&index=0&id=71fd36ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd36ea",
  null
  
)

export default component.exports